export default {
  tabPanelContent: (theme) => ({
    minHeight: 100,
    padding: `${theme.spacing(3)} 0`,
  }),
};
